var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 3.99935V3.33268C14.6667 2.96602 14.3667 2.66602 14 2.66602C13.6333 2.66602 13.3333 2.96602 13.3333 3.33268V3.99935H12.6667C12.3 3.99935 12 4.29935 12 4.66602C12 5.03268 12.3 5.33268 12.6667 5.33268H13.3333V5.99935C13.3333 6.36602 13.6333 6.66602 14 6.66602C14.3667 6.66602 14.6667 6.36602 14.6667 5.99935V5.33268H15.3333C15.7 5.33268 16 5.03268 16 4.66602C16 4.29935 15.7 3.99935 15.3333 3.99935H14.6667Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33317 5.99935C6.8065 5.99935 7.99984 4.80602 7.99984 3.33268C7.99984 1.85935 6.8065 0.666016 5.33317 0.666016C3.85984 0.666016 2.6665 1.85935 2.6665 3.33268C2.6665 4.80602 3.85984 5.99935 5.33317 5.99935Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 6.66602C3.55333 6.66602 0 7.55935 0 9.33268V11.3327H10.6667V9.33268C10.6667 7.55935 7.11333 6.66602 5.33333 6.66602Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33984 0.699219C8.95318 1.40589 9.33318 2.32589 9.33318 3.33255C9.33318 4.33922 8.95318 5.25922 8.33984 5.96588C9.64651 5.79922 10.6665 4.69255 10.6665 3.33255C10.6665 1.97255 9.64651 0.865885 8.33984 0.699219Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.02 7.21875C11.6134 7.77208 12 8.46542 12 9.33208V11.3321H13.3334V9.33208C13.3334 8.36542 12.2734 7.65875 11.02 7.21875Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.2008fa3c.svg";
export { ForwardRef as ReactComponent };